import { ApiResponse } from '~/core/api';
import { StoryByTag } from '~/core/forge/types';

import { GoalieComparison, LandingGame } from '../../../../types';

export type PregameComponentFlags = {
    isGamePreviewVisible: boolean;
    isGoalieComparisonVisible: boolean;
    isPlayersToWatchVisible: boolean;
    isTeamRosterFirstVisible: boolean;
};

export const getPregameComponentFlags = (
    game: LandingGame,
    gamePreviewAPIResponse: ApiResponse<StoryByTag>
): PregameComponentFlags => {
    const isGamePreviewShown = !gamePreviewAPIResponse.isLoading && !!gamePreviewAPIResponse.data?.items?.[0];

    let isGoalieComparisonShown = false;
    const goalieComparison = game?.matchup?.goalieComparison;
    if (goalieComparison) {
        const isGoalieShown = (team: GoalieComparison) => team?.leaders.length > 0 || !!team?.teamTotals?.record;
        isGoalieComparisonShown = isGoalieShown(goalieComparison.awayTeam) || isGoalieShown(goalieComparison.homeTeam);
    }

    const skaterLeaders = game?.matchup?.skaterComparison?.leaders?.filter(
        (leader) => leader.awayLeader && leader.homeLeader
    );
    const isPlayersToWatchShown = (skaterLeaders?.length || 0) > 0;

    return {
        isGamePreviewVisible: isGamePreviewShown,
        isGoalieComparisonVisible: isGoalieComparisonShown,
        isPlayersToWatchVisible: isPlayersToWatchShown,
        isTeamRosterFirstVisible: !isGamePreviewShown && !isGoalieComparisonShown && !isPlayersToWatchShown,
    };
};
